import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Divider,
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel
} from "@mui/material";
import { Navigate } from "react-router-dom";
import config from "../../../config.js";

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar'

// const ComplaintTypes = {
//   EOelectrical: "ELECTRICAL MAINTENANCE",
//   EOcivil: "ESTATE - CIVIL MAINTENANCE",
//   EOac: "REFRIGERATION AND AIR CONDITIONING MAINTENANCE",
//   DCSE: "COMPUTER MAINTENANCE",
//   DEMT: "COMPUTER NETWORKING / TELEPHONE"
// };

const ComplaintForm = () => {
  const [workOrderTitle, setWorkOrderTitle] = useState("");
  const [workOrderRaiser, setWorkOrderRaiser] = useState("");
  const [contactNum, setContactNum] = useState("");
  const [workOrderBody, setWorkOrderBody] = useState("");
  const [workOrderType, setWorkOrderType] = useState('');
  const [workOrderTypes, setWorkOrderTypes] = useState([]);
  const [subWorkOrderTypes, setSubWorkOrderTypes] = useState([]);
  const [selectedSubWorkOrderTypes, setSelectedSubWorkOrderTypes] = useState([]);
  const [subWorkOrderType, setSubWorkOrderType] = useState('');
  const [workOrderVenue, setWorkOrderVenue] = useState("");
  const [contact, setContact] = useState("");
  const [validationMsg, setValidationMsg] = useState("");
  //alert
  const [alert, setAlert] = useState({ open: false, message: '', severity:'success' , variant:'filled' });

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };
  
  const userId = localStorage.getItem('userId');
  const deptId = localStorage.getItem('department_id');

  const getWorkOrderTypes = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/getworkordertypes`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setWorkOrderTypes(jsonData);
    } catch (err) {
      console.error(err.message)
    } 
  }

  
  const getSubWorkOrderTypes = async () => {
    try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/getsubworkordertypes`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setSubWorkOrderTypes(jsonData);
    } catch (err) {
      console.error(err.message)
    } 
  }

  useEffect(()=>{
    getWorkOrderTypes();
    getSubWorkOrderTypes();
  },[])

  const onSubmitform = async (e) => {
    e.preventDefault();

    if(workOrderType === ''){
      setValidationMsg('select workorder type')
      return
    }
    if(workOrderBody === ''){
      setValidationMsg('Enter body of the complaint')
      return
    }
    if(workOrderVenue === ''){
      setValidationMsg('Enter venue')
      return
    }
    if(workOrderRaiser === ''){
      setValidationMsg('Enter Workorder raiser name')
      return
    }
    if (contactNum.length !== 10) {
      setValidationMsg("Contact number must be exactly 10 digits.");
      return;
    }
    try {
      const body = {
        workOrderTitle,
        workOrderBody, 
        workOrderType, 
        subWorkOrderType, 
        workOrderVenue, 
        contact, 
        userId,
        deptId
      };
      // const request = await fetch(`${config.BASE_URL_IP}/wob/mycomplaints`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(body)
      // });

      const response = await fetch(`${config.BASE_URL_IP}/wob/todos/${userId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      console.log(response);
      setAlert({ open: true, message: 'Complaint submitted successfully.', severity: 'success', variant:"filled" });
      setTimeout(function(){window.location.reload()}, 4000);
    } catch (err) {
      console.error(err.message);
    }
  };


  const handleWorkOrderTypeChange = async (val) => {
    setWorkOrderType(val);
    setSubWorkOrderType('');
    console.log(val);
    // await new Promise((resolve) => setTimeout(resolve, 0));
    // console.log(workOrderType);
    // const result = subWorkOrderTypes.find(subWorkOrderType => subWorkOrderType.complaint_type_id === val);
    // setSelectedSubWorkOrderTypes(result);
    // await new Promise((resolve) => setTimeout(resolve, 0));
    // console.log(result);
    // console.log(selectedSubWorkOrderTypes);
  };

  useEffect(() => {
    console.log(workOrderType);
    const result = subWorkOrderTypes.filter(subWorkOrderType => subWorkOrderType.complaint_type_id === workOrderType);
    setSelectedSubWorkOrderTypes(result);
    console.log(result);
  }, [workOrderType]);

  useEffect(() => {
    console.log(selectedSubWorkOrderTypes);
  }, [selectedSubWorkOrderTypes]);

  const handleSubWorkOrderTypeChange = (val) => {
    setSubWorkOrderType(val);
    console.log(val);
  };

  useEffect(() => {
    console.log(subWorkOrderType);
  }, [])

  useEffect(() => {
    const workOrderTypeObj = workOrderTypes.find(
      (type) => type.complaint_type_id === workOrderType
  );
  const subWorkOrderTypeObj = subWorkOrderTypes.find(
      (subType) => subType.sub_complaint_type_id === subWorkOrderType
  );
  const newTitle = `${workOrderTypeObj ? workOrderTypeObj.complaint_type : ''} ${subWorkOrderTypeObj ? subWorkOrderTypeObj.sub_complaint_type : ''}`.trim();

  setWorkOrderTitle(newTitle);
}, [workOrderType, subWorkOrderType]);

  useEffect(() => {
    setContact(contactNum + " " + workOrderRaiser);
  },[contactNum, workOrderRaiser])

  const handleMouseOver = (event) => {
    event.target.style.backgroundColor = "#09B3CE";
  };

  const handleMouseOut = (event) => {
    event.target.style.backgroundColor = "#15D2F0";
  };

  const handleMouseDown = (event) => {
    event.target.style.backgroundColor = "#3e8e41";
  };

  const handleMouseUp = (event) => {
    event.target.style.backgroundColor = "#09B3CE";
  };

  const handleChange = (e) => {
    const onlyNumbers = e.target.value.replace(/[^\d]/g, "");
    const truncated = onlyNumbers.slice(0, 10);
    setContactNum(truncated);

    if (truncated.length === 10) {
      setValidationMsg("");
    } else {
      setValidationMsg("Contact number must be exactly 10 digits.");
    }
  };
  
  return (
    <div>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity={alert.severity} variant={alert.variant}>
          {alert.message}
        </Alert>
      </Snackbar>
      <Card variant="outlined">
        <Box sx={{ padding: "15px 30px" }}>
          <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
            New Work-Order
          </Typography>
        </Box>
        <Divider />
        <CardContent sx={{ padding: "30px" }}>
          <form onSubmit={onSubmitform}>
            <div>
              <InputLabel id="demo-simple-select-standard-label">
                Work-Order Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                label="WorkOrderType"
                value={workOrderType}
                onChange={(e) => handleWorkOrderTypeChange(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              >
                <MenuItem value="Work-Order Type" disabled defaultChecked>
                  <em>Work-Order Type</em>
                </MenuItem>
                {workOrderTypes.map((workOrderType) => (
                  <MenuItem key={workOrderType.complaint_type_id} value={workOrderType.complaint_type_id}>
                    {workOrderType.complaint_type}
                  </MenuItem>
                ))}
              </Select>
              { (selectedSubWorkOrderTypes !== undefined && selectedSubWorkOrderTypes.length !== 0) && (
                <>
                  <InputLabel id="sub-workorder-type-label">
                    Sub Work-Order Type
                  </InputLabel>
                  <Select
                    labelId="sub-workorder-type-label"
                    id="sub-workorder-type"
                    label="SubWorkOrderType"
                    value={subWorkOrderType}
                    onChange={(e) => handleSubWorkOrderTypeChange(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="Sub Work-Order Type" disabled defaultChecked>
                      <em>Sub Work-Order Type</em>
                    </MenuItem>
                    {selectedSubWorkOrderTypes.map((subWorkOrderType) => (
                      <MenuItem key={subWorkOrderType.sub_complaint_type_id} value={subWorkOrderType.sub_complaint_type_id}>
                        {subWorkOrderType.sub_complaint_type}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}
            </div>
            
            <TextField
              labelId="desc"
              id="outlined-multiline-static"
              multiline
              rows={1}
              label="Work-Order Title"
              variant="outlined"
              value={workOrderTitle}
              sx={{ mb: 2 }}
              fullWidth
              disabled
              required
            />

            <TextField
              labelId="desc"
              id="outlined-multiline-static"
              multiline
              rows={7}
              label="Work-Order Body"
              variant="outlined"
              value={workOrderBody}
              onChange={(e) => setWorkOrderBody(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              required
            />

            <TextField
              labelId="venue"
              id="outlined-multiline-static"
              multiline
              label="Work-Order Venue"
              variant="outlined"
              placeholder="e.g: 1st floor IT"
              value={workOrderVenue}
              onChange={(e) => setWorkOrderVenue(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              required
            />

            <TextField
              id="work-order-raiser"
              label="Work Order Raiser Name"
              variant="outlined"
              placeholder="e.g: Subha Chella"
              value={workOrderRaiser}
              onChange={(e) => setWorkOrderRaiser(e.target.value)}
              fullWidth
              inputMode="text"
              sx={{ mb: 2 }}
              required
            />
            <TextField
              id="contact"
              label="Contact Information"
              variant="outlined"
              placeholder="e.g., 9712345678"
              value={contactNum}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
              inputProps={{
                maxLength: 10, // Limit to 10 characters
                inputMode: "numeric" // Ensure only numeric input
              }}
              required
            />
            {validationMsg && (
              <Typography variant="body2" color="error">
                {validationMsg}
              </Typography>
            )}
          
            <button
              variant="contained"
              onClick={onSubmitform}
              style={{
                display: "inline-block",
                padding: "12px 24px",
                fontSize: "20px",
                fontWeight: "bold",
                cursor: "pointer",
                borderRadius: "20px",
                color: "#ffffff",
                backgroundColor: "#15D2F0",
                transition: "background-color 0.3s ease",
                outline: "none",
                overflow: "hidden"
              }}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              onMouseDown={handleMouseDown}
              onMouseUp={handleMouseUp}
            >
              SUBMIT
            </button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComplaintForm;